import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AnalyticsService, AnalyticsUtility } from 'src/app/services/analytics/analytics.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { FilterMappingService } from 'src/app/services/results/filter-mapping.service';
import { constants } from 'src/environments/constants';

@Component({
  selector: 'app-feature-filters',
  templateUrl: './feature-filters.component.html',
  styleUrls: ['./feature-filters.component.scss']
})
export class FeatureFiltersComponent implements OnInit {
  @Output() featuresToFilterBy: EventEmitter<string[]> = new EventEmitter();
  selectedFeatures: string[] = [];
  title: string = "";
  touchscreenKeyword: string = "";
  touchscreenLabel: string = "";

  constructor(private analytics: AnalyticsService, private confSvc: ConfigService, private filterMapper: FilterMappingService) { }

  async ngOnInit(): Promise<void> {
    await this.confSvc.setup();

    this.title = this.confSvc.getString("featuresFilterTitle");
    this.touchscreenKeyword = constants.TOUCHSCREEN;
    this.touchscreenLabel = this.filterMapper.getFeatureFilterLabel(this.touchscreenKeyword);
  }

  featureIsSelected(feature: string): boolean {
    return this.selectedFeatures.some(f => f === feature);
  }

  onFeatureChange(feature: string): void {
    const indexOfFeature = this.selectedFeatures.indexOf(feature);
    indexOfFeature < 0 ? this.selectedFeatures.push(feature) : this.selectedFeatures.splice(indexOfFeature, 1);
    this.featuresToFilterBy.emit(this.selectedFeatures);
    this.analytics.logCheckboxFilterClick(AnalyticsUtility.filterType.feature, feature, indexOfFeature < 0);
  }
}
